export default __webpack_public_path__ + "static/media/smtp2go.a7a27995.svg";